import { render, staticRenderFns } from "./transverse.vue?vue&type=template&id=7376e4d7"
import script from "./transverse.vue?vue&type=script&lang=js"
export * from "./transverse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7376e4d7')) {
      api.createRecord('7376e4d7', component.options)
    } else {
      api.reload('7376e4d7', component.options)
    }
    module.hot.accept("./transverse.vue?vue&type=template&id=7376e4d7", function () {
      api.rerender('7376e4d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/main/transverse.vue"
export default component.exports